import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { Divider, LoadingButton } from 'base-ui'

import { useProductAddToCartButtonTracking } from '../ProductBuyBox/ProductAddToCartGroup/ProductAddToCartCta/useProductAddToCartButtonTracking'

import { AppDownloadBanner } from './app-download'
import { useRxPdpAppRedemptionTracking } from './useRxPdpAppRedemptionTracking'

export const ProductAddToCartAppRedemption: FC<{
  disabled?: boolean
  isSticky?: boolean
  loading: boolean
  onPaperClick?: () => void
}> = ({ disabled = false, isSticky = false, loading, onPaperClick }) => {
  const trackAddToCartButton = useProductAddToCartButtonTracking()
  const tracking = useRxPdpAppRedemptionTracking()

  return (
    <div className="flex flex-col gap-3" data-qa-id="rx-pdp-app-activation">
      <AppDownloadBanner />
      <Divider>
        <FormattedMessage id="rxPdpAppActivation.divider" />
      </Divider>
      <LoadingButton
        className="w-full font-normal"
        color="secondary"
        data-qa-id="rx-pdp-paper-prescription-button"
        disabled={disabled || loading}
        loading={loading}
        onClick={() => {
          trackAddToCartButton()
          tracking?.track({ action: 'paper_cta_click', placement: 'buy-box' })
          onPaperClick?.()
        }}
        size="large"
        type={isSticky ? 'button' : 'submit'}
      >
        <FormattedMessage id="rxPdpAppActivation.paper.cta" />
      </LoadingButton>
    </div>
  )
}
